<script lang="ts" setup>
defineProps<{
  availabilityLink?: string
}>()
</script>

<template>
  <a v-if="availabilityLink" :href="availabilityLink" class="availability-link" target="_blank">
    <span>{{ $t('global.availability') }}</span>
    <i class="ic-info-circle" />
  </a>
</template>

<style lang="scss" scoped>
@import '@/assets/style/helpers/include-media';

.availability-link {
  display: flex;
  align-items: center;
  background: #e5e5e5;

  text-decoration: none;
  padding: 0.25rem 0.75rem;
  margin-left: 2rem;

  @include media('<tablet') {
    margin-left: 0;
  }

  @include themify($themes) {
    border-radius: rem-calc(themed('btnBorderRadius'));
  }

  i {
    margin-left: 0.5rem;
    font-size: 1.125rem;
  }
}
</style>
